import React, { useState } from 'react';

/**
 * MigrationBanner — Shown during domain transition (arenastats.com.br → vukz.ai).
 * 
 * Controlled by env var REACT_APP_SHOW_MIGRATION_BANNER.
 * Set to "true" to display, remove or set "false" to hide.
 * 
 * Appears on BOTH old and new domains during the transition period.
 * Users can dismiss it for the current session (persists in sessionStorage).
 */

const BRAND_GREEN = '#064e3b';
const BRAND_GOLD = '#b48c2c';
const NEW_DOMAIN = 'https://vukz.ai';

const MigrationBanner = () => {
  const [dismissed, setDismissed] = useState(
    () => sessionStorage.getItem('migration_banner_dismissed') === '1'
  );

  // Check feature flag
  const showBanner =
    window.ENV?.REACT_APP_SHOW_MIGRATION_BANNER === 'true' ||
    process.env.REACT_APP_SHOW_MIGRATION_BANNER === 'true';

  if (!showBanner || dismissed) return null;

  const isAlreadyOnNewDomain = window.location.hostname === 'vukz.ai' || window.location.hostname === 'www.vukz.ai';

  const handleDismiss = () => {
    sessionStorage.setItem('migration_banner_dismissed', '1');
    setDismissed(true);
  };

  return (
    <div
      className="w-full px-4 py-2 flex items-center justify-center gap-3 text-sm font-medium relative z-50"
      style={{
        background: `linear-gradient(90deg, ${BRAND_GREEN} 0%, #047857 100%)`,
        color: '#ffffff',
      }}
    >
      <span className="text-base">🚀</span>
      <span>
        {isAlreadyOnNewDomain
          ? 'Bem-vindo ao novo domínio! Você já está em vukz.ai.'
          : 'Novo domínio: nosso endereço mudou para vukz.ai'}
      </span>
      {!isAlreadyOnNewDomain && (
        <a
          href={NEW_DOMAIN + window.location.pathname}
          className="ml-1 px-3 py-1 rounded-full text-xs font-bold transition-all hover:opacity-90"
          style={{ backgroundColor: BRAND_GOLD, color: '#ffffff' }}
        >
          Ir para vukz.ai →
        </a>
      )}
      <button
        onClick={handleDismiss}
        className="absolute right-3 top-1/2 -translate-y-1/2 text-white/70 hover:text-white transition-colors"
        aria-label="Fechar banner"
      >
        ✕
      </button>
    </div>
  );
};

export default MigrationBanner;
